<button class="theme-btn style-one" type="button" data-toggle="tooltip"
    title="Please maintain 5 minutes gap for every Refresh." (click)="refreshData()" class="theme-btn style-one">Refresh
    Report</button>
<app-loader></app-loader>